import { VEHICLE_CLASSES, type VehicleClass } from '../lib/types';

export default function VehicleClassPicker({
  value,
  onChange,
}: {
  value: VehicleClass;
  onChange: (v: VehicleClass) => void;
}) {
  return (
    <div className="glass inline-flex flex-wrap justify-center gap-1 rounded-2xl p-1.5">
      {VEHICLE_CLASSES.map((vc) => (
        <button
          key={vc.id}
          onClick={() => onChange(vc.id)}
          className={`rounded-xl px-4 py-2.5 text-sm font-semibold transition-all duration-200 ${
            value === vc.id
              ? 'bg-gradient-to-r from-accent-600 to-sky-500 text-white shadow-lg'
              : 'text-zinc-400 hover:bg-white/[0.05] hover:text-white'
          }`}
          title={vc.example}
        >
          {vc.label}
        </button>
      ))}
    </div>
  );
}
